<template>
    <section id="Achievements">
        <div v-if="achievementsData.error">
            Error code: {{ achievementsData.httpcode }}
        </div>
        <div v-if="!achievementsData.playerstats.achievements">
            No achievements for this game.
        </div>

        <div class="banner">
            <h2>{{gameSchema.game.gameName}} ({{progressTotal}})</h2>
            <a href="#" class="totop">to top</a>
        </div>

        <!--<div style="width:40%; display: inline-block; overflow: hidden;"><pre>{{gameSchema.game.availableGameStats}}</pre></div>
        <div style="width:40%; display: inline-block; vertical-align: top;"><pre>{{achievementsData}}</pre></div>-->

        <ul v-if="gameSchema.game.availableGameStats.achievements">
            <li v-for="achievement in gameSchema.game.availableGameStats.achievements"
                v-bind:class="{'done':isAchieved(achievement)}">
                    <img v-bind:src="apiImage(achievement.icongray)" v-bind:alt="achievement.displayName" v-if="!isAchieved(achievement)">
                    <img v-bind:src="apiImage(achievement.icon)" v-bind:alt="achievement.displayName" v-else>
                    <dl class="text">
                        <dt>{{ achievement.displayName }}</dt>
                        <dd>{{ achievement.description }}</dd>
                    </dl>
            </li>
        </ul>

    </section>
</template>

<script>
    export default{
        props: {
            achievementsData: {
                type: Object
            },
            gameSchema: {
                type: Object
            },
            api: {
                type: String
            }
        },
        computed: {
            achieved() {
                let achieved = [];
                if(this.achievementsData.playerstats.achievements){
                    for (let i=0; i<this.achievementsData.playerstats.achievements.length; i++){
                        achieved.push(this.achievementsData.playerstats.achievements[i].name);
                    }
                }

                return achieved;
            },
            progressTotal() {
                return this.achievementsData.playerstats.achievements.length +' von '+ this.gameSchema.game.availableGameStats.achievements.length;
            }
        },
        methods:{
            isAchieved(achievement){
                let name = achievement.name;
                return (this.achieved.indexOf(name) !== -1);
            },
            apiImage(url) {
                let parts = url.split("/");
                return `${this.api}/img/${parts[7]}/${parts[8].replace('.jpg','')}`;
            }
        },
        mounted() {
            window.location.href = '#Achievements';
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/variables.scss";

    $gap: 20px;

    ul {
        list-style: none;
        margin: 0 0 0 -#{$gap};
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
    }
    li {
        flex: 1 1 calc(184px * 2 - $gap);
        order: 2;
        margin-left: $gap;
        margin-bottom: $gap;
        width: 100%;
        display: flex;
        background-color: black;
        color: white;
        line-height: 1.5rem;
        align-items: flex-start;

        @media (min-width: 816px) {
            width: calc(100%/2 - #{$gap});
        }
        @media (min-width: 1224px) {
            width: calc(100%/3 - #{$gap});
        }
        @media (min-width: 1632px) {
            width: calc(100%/4 - #{$gap});
        }


    }
    .done {
        order: 1;
    }
    img {
        width: 64px;
        height: 64px;
        flex: 0 0 auto;
    }
    .text {
        margin: 0.2em 1em;
    }
    dl, dt, dd {
        margin: 0;
        padding: 0;
    }
    dt {
        font-weight: bold;
        font-size: 15px;
        color: $color-text-light;
    }
    dd {
        font-size: 12px;
        line-height: 1.3;
        color: $color-text-muted;
    }

    .banner {
        display: flex;
        justify-content: space-between;
        background-color: black;
        margin-bottom: $gap;

        &>* {
            margin: 0;
            padding: 10px;
        }
    }

    .totop {
        font-size: 0.8rem;
    }
</style>


// WEBPACK FOOTER //
// PlayerGameAchievements.vue?93d1ca14